import { createAction, props } from '@ngrx/store';
import { Area } from '@cue/data';

export const loadAreas = createAction('[Areas] Load');

export const areasLoaded = createAction('[Areas] Loaded', props<{ areas: Area[] }>());
